export const facingDirections = [
  "bac",
  "dong_bac",
  "dong",
  "dong_nam",
  "nam",
  "tay_nam",
  "tay",
  "tay_bac",
] as const;

export type FacingDirection = (typeof facingDirections)[number];

export const facingDirectionLabels = {
  bac: "Bắc",
  dong_bac: "Đông Bắc",
  dong: "Đông",
  dong_nam: "Đông Nam",
  nam: "Nam",
  tay_nam: "Tây Nam",
  tay: "Tây",
  tay_bac: "Tây Bắc",
} as const;

const sectors = facingDirections.map((id) => facingDirectionLabels[id]);

export function compassLabel(degrees: number): string {
  const normalized = ((Math.round(degrees) % 360) + 360) % 360;
  const index = Math.round(normalized / 45) % 8;
  return sectors[index];
}
